// extracted by mini-css-extract-plugin
export default {"checkmark":"Checkbox_checkmark__IVDp4","checkbox":"Checkbox_checkbox__1AHxm","checkmark_container":"Checkbox_checkmark_container__JuvR7","label":"Checkbox_label__cMcxA"};